import {
  Form,
  Modal,
  Input,
  Button,
  Select,
  Space,
  InputNumber,
  DatePicker,
  Upload,
  message,
} from "antd";
import React, { useEffect, useState } from "react";
import { getDirectusClient } from "../../../lib/directus";
import { useForm } from "antd/es/form/Form";
import {
  readItems,
  readRoles,
  readUsers,
  updateUser,
  uploadFiles,
} from "@directus/sdk";
import { useSelector } from "react-redux";
import {
  obtenerCamposUser,
  EditValorCampousers,
  ObtenerValoresCampo,
} from "../../../services/formularioUsuarios";
import { InboxOutlined } from "@ant-design/icons";

const { Option } = Select;
const { Dragger } = Upload;

function Editseller(props) {
  const [roles, setRoles] = useState([]);
  const [bodegas, setBodegas] = useState([]);
  const [prestamo, setPrestamo] = useState(false);
  const [users, setUsers] = useState([]);
  const [selectedBodega, setSelectedBodega] = useState(null);
  const [selectedRole, setSelectedRole] = useState(null);
  const userRoleID = useSelector((state) => state.userdata.role?.name);
  const userBodega = useSelector((state) => state.userdata.bodega?.id);
  const [camposDinamicos, setCamposDinamicos] = useState([]);
  const [valoresCampos, setValoresCampos] = useState([]);
  const [archivosPendientes, setArchivosPendientes] = useState({});

  const [form] = useForm();

  const Roles = async () => {
    const directus = await getDirectusClient();

    directus
      .request(
        readRoles({
          fields: ["id", "name", "vende"],
          filter: {
            name: {
              _nin: ["Administrator", "adminapp"],
            },
          },
        })
      )
      .then((res) => {
        console.log("Roles:", res);
        setRoles(res);
      })
      .catch((err) => console.log("Error roles:", err));
  };

  const Bodegas = async () => {
    const directus = await getDirectusClient();

    directus
      .request(
        readItems("bodegas", {
          fields: ["id", "nombre"],
          filter: {
            ...(userRoleID !== "adminapp" && userRoleID !== "Administrator"
              ? {
                  id: { _eq: userBodega },
                }
              : {}),
          },
        })
      )
      .then((res) => {
        console.log("Bodegas:", res);
        setBodegas(res);
      })
      .catch((err) => console.log("Error bodegas:", err));
  };

  const getUsers = async (bodegaId) => {
    const directus = await getDirectusClient();

    directus
      .request(
        readUsers({
          fields: [
            "id",
            "first_name",
            "last_name",
            "email",
            "documento",
            "role.name",
            "role.id",
            "superior.id",
            "bodega.id",
            "bodega.nombre",
            "tope_de_prestamo",
            "status",
          ],
          limit:-1,
          filter: {
            _and: [
             
              {
                bodega: {
                  id: {
                    _eq: bodegaId,
                  },
                },
              },
            ],
          },
        })
      )
      .then((res) => {
        setUsers(res);
      })
      .catch((err) => {
        console.error("Error fetching users:", err);
        Modal.error({
          title: "Error",
          content: "Error al obtener los usuarios",
        });
      });
  };

  const handleRoleChange = async (selectedRoleId) => {
    try {
      const camposUser = await obtenerCamposUser();
      const rolesConCampos = camposUser.filter((campo) =>
        campo.roles.some((rol) => rol.directus_roles_id.id === selectedRoleId)
      );

      if (rolesConCampos.length > 0) {
        console.log(
          "El rol seleccionado tiene campos asociados:",
          rolesConCampos
        );
        setCamposDinamicos(rolesConCampos);
      } else {
        console.log("El rol seleccionado no tiene campos asociados.");
        setCamposDinamicos([]);
      }
    } catch (error) {
      console.error("Error al validar campos del rol:", error);
      setCamposDinamicos([]);
    }
  };

  const loadValoresCampos = async (userId) => {
    try {
      const valores = await ObtenerValoresCampo();
      const valoresFiltrados = valores.filter((valor) => valor.user === userId);
      setValoresCampos(valoresFiltrados);
    } catch (error) {
      console.error("Error al obtener los valores de los campos:", error);
    }
  };

  const onFinish = async (values) => {
    const directus = await getDirectusClient();

    try {
      const valoresActualizados = { ...values };
      for (const [campoId, file] of Object.entries(archivosPendientes)) {
        const formData = new FormData();
        formData.append("file", file);
        const response = await directus.request(uploadFiles(formData));
        if (response.id) {
          valoresActualizados[campoId] = response.id;
          message.success(`Imagen para ${campoId} subida correctamente`);
        }
      }

      const userResponse = await directus.request(
        updateUser(props.selectseller.id, valoresActualizados)
      );

      if (userResponse.id) {
        await Promise.all(
          camposDinamicos.map(async (campo) => {
            if (valoresActualizados[campo.campo]) {
              const valorExistente = valoresCampos.find(
                (valor) => valor.campos_users === campo.id
              );
              if (valorExistente) {
                await EditValorCampousers(valorExistente.id, {
                  valor: valoresActualizados[campo.campo],
                });
              }
            }
          })
        );

        props.closeUpdate();
        form.resetFields();
        setArchivosPendientes({});
        props.getSellers();
      }
    } catch (error) {
      console.error("Error al actualizar usuario o campos:", error);
      message.error("Error al guardar los cambios");
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const handleFileChange = (campoId, file) => {
    setArchivosPendientes((prev) => ({ ...prev, [campoId]: file }));
    return false;
  };

  const renderCampoImagen = (campo) => (
    <Dragger
      name={campo.campo}
      multiple={false}
      accept="image/*"
      beforeUpload={(file) => {
        handleFileChange(campo.campo, file);
        return false;
      }}
      showUploadList={true}
    >
      <p className="ant-upload-drag-icon">
        <InboxOutlined />
      </p>
      <p className="ant-upload-text">Click o arrastre una imagen</p>
      <p className="ant-upload-hint">Solo imágenes (JPEG, PNG, etc.)</p>
    </Dragger>
  );

  useEffect(() => {
    console.log("Selected seller:", props.selectseller);
    form.setFieldsValue({ first_name: props.selectseller.first_name });
    form.setFieldsValue({ last_name: props.selectseller.last_name });
    form.setFieldsValue({ documento: props.selectseller.documento });
    form.setFieldsValue({ email: props.selectseller.email });
    form.setFieldsValue({ role: props.selectseller.role?.id });
    form.setFieldsValue({ bodega: props.selectseller.bodega?.id });
    form.setFieldsValue({ superior: props.selectseller.superior?.id });
    form.setFieldsValue({ idremoto: props.selectseller.idremoto });
    form.setFieldsValue({
      tope_de_prestamo: props.selectseller.tope_de_prestamo,
    });
    form.setFieldsValue({
      status: props.selectseller.status,
    });

    if (props.selectseller.bodega?.id) {
      setSelectedBodega(props.selectseller.bodega.id);
      getUsers(props.selectseller.bodega.id);
    }

    if (props.selectseller.role?.id) {
      const selectedRole = roles.find(role => role.id === props.selectseller.role.id);
      setSelectedRole(selectedRole);
      // Cambiado: ahora también activa prestamo si el rol es "tropas"
      if (selectedRole?.vende || selectedRole?.name === "tropas") {
        setPrestamo(true);
      } else {
        setPrestamo(false);
      }
      handleRoleChange(props.selectseller.role.id);
    }

    if (props.selectseller.id) {
      loadValoresCampos(props.selectseller.id);
    }
  }, [props.selectseller, roles]);

  useEffect(() => {
    Roles();
    Bodegas();
    getUsers();
  }, []);

  return (
    <Modal
      open={props.opencreate}
      onCancel={props.closeUpdate}
      title="Editar usuario"
      footer={[
        <Button
          key="back"
          onClick={() => {
            props.closeUpdate();
            props.setSelectseller({});
          }}
        >
          cancelar
        </Button>,
        <Button key="submit" type="primary" onClick={() => form.submit()}>
          Guardar Cambios
        </Button>,
      ]}
    >
      <div style={{ margin: 20 }}>
        <Form
          form={form}
          name="basic"
          labelCol={{ span: 8 }}
          wrapperCol={{ span: 16 }}
          style={{ maxWidth: 600 }}
          initialValues={{ remember: true }}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
        >
          <Form.Item
            label="Nombre"
            name="first_name"
            rules={[{ required: true }]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            label="Apellidos"
            name="last_name"
            rules={[{ required: true }]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            label="Documento"
            name="documento"
            rules={[{ required: true }]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            label="Correo"
            name="email"
            rules={[{ required: true, type: "email" }]}
          >
            <Input />
          </Form.Item>

          <Form.Item name="role" label="Rol" rules={[{ required: true }]}>
            <Select
              placeholder="seleccione un rol"
              allowClear
              onChange={(select) => {
                console.log("Selected role:", select);
                const selectedRole = roles.find(role => role.id === select);
                setSelectedRole(selectedRole);
                console.log("selectedRole",selectedRole);
                // Cambiado: ahora también activa prestamo si el rol es "tropas"
                if (selectedRole?.vende || selectedRole?.name === "tropas") {
                  setPrestamo(true);
                } else {
                  setPrestamo(false);
                }
                handleRoleChange(select);
              }}
            >
              {roles?.map((rol) => {
                return (
                  <Option key={rol.id} value={rol.id}>
                    {rol.name}
                  </Option>
                );
              })}
            </Select>
          </Form.Item>

          {selectedRole?.name === "Aliados" && (
            <Form.Item
              label="ID Remoto"
              name="idremoto"
              rules={[{ required: true, message: 'Por favor ingrese el ID Remoto' }]}
            >
              <Input />
            </Form.Item>
          )}

          <Form.Item name="bodega" label="Bodega" rules={[{ required: true }]}>
            <Select
              placeholder="seleccione una Bodega"
              allowClear
              onChange={(value) => {
                setSelectedBodega(value);
                if (value) {
                  getUsers(value);
                } else {
                  setUsers([]);
                }
                form.setFieldValue("superior", undefined);
              }}
              
            >
              {bodegas?.map((bodega) => (
                <Option key={bodega.id} value={bodega.id}>
                  {bodega.nombre}
                </Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item
            name="superior"
            label="Superior"
            rules={[{ required: false }]}
          >
            <Select
              placeholder="seleccione un Superior"
              allowClear
              disabled={!selectedBodega}
              showSearch
              filterOption={false}
              onSearch={(value) => {
                if (value) {
                  const filteredUsers = users.filter(user => 
                    `${user.first_name} ${user.last_name}`.toLowerCase().includes(value.toLowerCase())    
                  );
                  setUsers(filteredUsers);
                } else {
                  getUsers(selectedBodega);
                }
              }}
              style={{ width: "100%" }}
            >
              {users?.map((user) => (
                <Option key={user.id} value={user.id}>
                  {user.first_name} {user.last_name}
                  <span style={{ fontSize: "12px", color: "green" }}>
                    {user.role?.name}
                  </span>
                </Option>
              ))}
            </Select>
          </Form.Item>

          {/* Cambiado: el campo de tope_de_prestamo aparece si prestamo es true */}
          {prestamo ? (
            <>
              <Form.Item
                label="Tope de prestamo"
                name="tope_de_prestamo"
                rules={[{ required: false }]}
              >
                <InputNumber />
              </Form.Item>
            </>
          ) : null}
          <Form.Item
            label="Estatus"
            name="status"
            rules={[{ required: false }]}
          >
            <Select>
              <Option value="active">Activo</Option>
              <Option value="suspended">Suspendido</Option>
            </Select>
          </Form.Item>
          <Form.Item
            label="Contraseña"
            name="password"
            rules={[{ required: false }]}
          >
            <Input.Password />
          </Form.Item>

          {camposDinamicos.map((campo) => {
            let opcionesArray = [];
            if (campo.opciones) {
              try {
                const opcionesString = campo.opciones
                  .replace(/[{"}]/g, "")
                  .replace(/\\/g, "");
                opcionesArray = opcionesString
                  .split(",")
                  .map((opcion) => opcion.trim());
              } catch (error) {
                console.error("Error al parsear opciones:", error);
              }
            }

            const valorCampo = valoresCampos.find(
              (valor) => valor.campos_users === campo.id
            );

            return (
              <Form.Item
                key={campo.id}
                label={campo.campo}
                name={campo.campo}
                initialValue={valorCampo?.valor}
                rules={[{ required: campo.tipo_campo === "obligatorio" }]}
              >
                {campo.tipo_campo === "texto" && <Input />}
                {campo.tipo_campo === "numero" && <InputNumber />}
                {campo.tipo_campo === "select" && (
                  <Select placeholder={`Seleccione ${campo.campo}`}>
                    {opcionesArray.map((opcion) => (
                      <Option key={opcion} value={opcion}>
                        {opcion}
                      </Option>
                    ))}
                  </Select>
                )}
                {campo.tipo_campo === "fecha" && (
                  <DatePicker style={{ width: "100%" }} format="DD/MM/YYYY" />
                )}
                {campo.tipo_campo === "imagen" && renderCampoImagen(campo)}
              </Form.Item>
            );
          })}
        </Form>
      </div>
    </Modal>
  );
}

export default Editseller;
